<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
      <div class="d-flex align-items-center">
      </div>
      <div class="d-sm-flex align-items-center">
        <button @click="telecharger" v-if="valideEtape3" :disabled="isLoading"
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none"
          type="button">
          <i class="flaticon-download position-relative ms-5 fs-12"></i>
          <span v-if="!isLoading">Exporter</span>
          <span v-else>
            <span class="spinner-grow spinner-grow-sm me-2" role="status" aria-hidden="true"></span>
            Export en cours...
          </span>
        </button>
        <button
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-secondary fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none"
          type="button" v-if="!valideEtape3" disabled>
          <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
          <span class="visually-hidden">Chargement...</span>
        </button>
      </div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="col-md-12">
        <div class="row">
          <div class="col">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Mot clé
              </label>
              <Field style="max-height: 42px;" v-model="motCle" name="mot" type="text" aria-disabled="true"
                class="form-control shadow-none fs-md-15 text-black" placeholder="Recherche par mot clé" />
            </div>
          </div>

          <div class="col">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Secteur <span class="text-danger">*</span>
              </label>
              <Field name="secteur" v-model="secteur" v-slot="{ field }">
                <Multiselect :options="secteursOptions" :searchable="true" v-bind="field"
                  placeholder="Sélectionner un secteur" />
              </Field>
              <ErrorMessage name="secteur" class="text-danger" />
            </div>
          </div>
          <div class="col-2">
            <label class="d-block text-black fw-semibold mb-10" style="opacity: 0%;">
              _
            </label>
            <a type="button" @click="soumission" class="btn btn-outline-success">Valider</a>
          </div>
        </div>
      </div>
      <hr>
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <!-- <th class="shadow-none lh-1 fw-medium text-primary">
                    <input class="form-check-input shadow-none me-8 mt-0" type="checkbox" v-model="selectAllCheckbox">
                  <input
                        class="form-check-input shadow-none me-8 mt-0"
                        type="checkbox"
                        @click="check()"
                      />
                </th>-->
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Secteur
              </th>
              <!-- <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                >
                  Numéro Compte
                </th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                >
                  Ancien code
                </th>-->
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Nouveau Code
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Locataire
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Exploitant
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Loyer
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Arrièrés
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Statut
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0">
                Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(contrat, index) in contratEmplacements" :key="index">
              <td class="shadow-none lh-1 fw-medium text-primary">
                {{ contrat.libelle_secteur }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-primary">
                {{ contrat.ncode_emp }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ (contrat.usagerLocataire) }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ (contrat.exploitant) }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ formatWithThousandSeparator(contrat.loyer) }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ formatWithThousandSeparator(contrat.too) }}
              </td>
              <td class="shadow-none lh-1 fw-medium pe-0">
                <span v-if="contrat.etat == 0 || contrat.etat == null" class="badge text-outline-danger">En
                  attente</span>
                <span v-else class="badge text-outline-primary">Validé</span>
              </td>
              <td class="shadow-none lh-1 fw-medium text-end pe-0 sm">
                <div class="dropdown">
                  <span class="badge text-white bg-primary fs-15 dropdown-toggle" data-bs-toggle="dropdown"
                    aria-expanded="false">
                    Actions
                    <i class="flaticon-chevron-2 position-relative ms-5 top-2 fs-15"></i>
                  </span>
                  <ul class="dropdown-menu">
                    <li>
                      <a type="button" class="dropdown-item d-flex align-items-center" @click="ajoutArr(contrat.id)"
                        data-bs-toggle="modal" data-bs-target="#VoirDetails">
                        <i class="flaticon-view lh-1 me-8 position-relative top-1"></i>
                        Consulter détails
                      </a>
                    </li>
                    <li>
                      <a type="button" class="dropdown-item d-flex align-items-center" @click="ajoutArr(contrat.id)"
                        data-bs-toggle="modal" data-bs-target="#AddArrieresModal">
                        <i class="flaticon-edit lh-1 me-8 position-relative top-1"></i>
                        Modifier
                      </a>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center">
        <PaginationComponent :page="page" :totalPages="totalPages" :totalElements="totalElements" :limit="limit"
          @paginate="handlePaginate" />
      </div>
    </div>
  </div>
  <AddArrieresModal :item="selectedItem" :type="typeT" @close="recharger" @openmodal="show_Modal" />
  <VoirDetails :item="selectedItem" :secteur="secteur" @close="recharger" @openmodal="show_Modal" />
</template>
<script lang="ts">
import { ref, defineComponent, onMounted, watch, computed, watchEffect } from "vue";
import { Form, Field, ErrorMessage } from 'vee-validate';
import { hideModal, showModal, success, error, separateur, suppression, getUrlApiForFiles, downloadExcel } from '@/utils/utils';
import { Contrat } from "@/models/Contrat";
import ApiService from "@/services/ApiService";
import { Option } from "@/models/Option";
import Swal from 'sweetalert2';
import VoirDetails from "./VoirDetails.vue";
import PaginationComponent from '@/components/Utilities/Pagination.vue';
import AddArrieresModal from "../Arrires/AddArrieresModal.vue";
import JwtService from "@/services/JwtService";
import Multiselect from '@vueform/multiselect';
import axios from "axios";

export default defineComponent({
  name: "ListeContrat",
  components: {
    PaginationComponent,
    // Form,
    AddArrieresModal,
    VoirDetails,
    Field,
    Multiselect,

  },
  setup: () => {
    const contrats = ref<Array<Contrat>>([]);
    const contrat = ref<Contrat>();
    const selectedItem = ref(0);
    const secteur = ref("")
    const typeT = ref("Modification")

    // BEGIN PAGINATE
    const searchTerm = ref('');
    const page = ref(1);
    const totalPages = ref(0);
    const limit = ref(10);
    const totalElements = ref(0);
    const secteursOptions = ref<Array<Option>>([]);
    const motCle = ref('');
    const checkboxes = ref<Array<boolean>>([]);
    const selectAllCheckbox = ref(false);
    // END PAGINATE
    const handlePaginate = ({ page_, limit_ }) => {
      try {
        page.value = page_;
        limit.value = limit_;
        actionRecherche(page_, limit_);
      } catch (error) {
        //
      }
    };

    function formatWithThousandSeparator(num: string): string {
      const num2 = parseFloat(num);
      return num2.toLocaleString("fr-FR");
    }

    const ajoutArr = (id: number) => {
      selectedItem.value = id;
    };

    watch(selectAllCheckbox, (newValue, oldValue) => {
      if (newValue != oldValue) {
        selectAllCheckbox.value = newValue;
        for (let i = 0; i < checkboxes.value.length; i++) {
          checkboxes.value[i] = newValue;
        }
      }
    });
    const selectAll = ref(false);
    const selectedContracts = ref(false);

    function handleSelectAll() {
      if (selectAll.value) {
        // selectedContracts.value = contratEmplacements.value.map(contrat => contrat?.id);
      } else {
        // selectedContracts.value = [];
      }
    }
    const recharger = () => {
      actionRecherche(page.value, limit.value);
    };
    const show_Modal = (el) => {
      showModal(el);
      selectedItem.value = 0;
    };

    const recupereSecteurs = async () => {
      try {
        const response = await axios.get('/secteur');
        const donneee = response.data.data;
        secteursOptions.value = donneee.map((secteur) => ({
          label: `${secteur.code_secteur} -- [ ${secteur.libelle_secteur} ]`,
          value: secteur.code_secteur,
          disabled: false
        }));
        return secteursOptions.value;
      } catch (error) {
        //
      }
    }
    const contratEmplacements = ref([]);

    const actionRecherche = async (page = 1, limi = 10, searchTerm = '') => {
      // if(secteur.value == ''){
      //   error("Veuillez selectionnez un secteur")
      //   return;
      // }else{
      const element = {
        secteur: secteur.value,
        motCle: motCle.value,
        page: page,
        totalPages: totalPages.value,
        limit: limi,
        totalElements: totalElements.value,
        mot: searchTerm
      };
      try {
        const response = await axios.post('/contrat/ayant/arrieres', element);
        contratEmplacements.value = response.data.data.data;
        totalPages.value = response.data.data.totalPages;
        limit.value = response.data.data.limit;
        totalElements.value = response.data.data.totalElements;
        //return  contratEmplacements.value;
        for (let i = 0; i < contratEmplacements.value.length; i++) {
          checkboxes.value.push(false)
        }
      } catch (error) {
        //
      }
      // }

    }
    watch(secteur, (newValue, oldValue) => {
      page.value = 1;
      limit.value = 10;
      totalPages.value = 0;
      totalElements.value = 0;
      secteur.value = newValue;
      actionRecherche(page.value, limit.value);
    });
    watch(motCle, (newValue, oldValue) => {
      page.value = 1;
      limit.value = 10;
      totalPages.value = 0;
      totalElements.value = 0;
      motCle.value = newValue;
      actionRecherche(page.value, limit.value);
    });
    onMounted(() => {
      recupereSecteurs();
      actionRecherche(1, 10);
    });

    const checkedItems = ref<Array<number>>([]); // Tableau pour suivre les éléments cochés
    
    // Variables pour l'export
    const valideEtape3 = ref(true);
    const isLoading = ref(false);

    const handleChange = (id: number) => {
      if (checkedItems.value.includes(id)) {
        checkedItems.value.splice(checkedItems.value.indexOf(id), 1);
      } else {
        checkedItems.value.push(id);
      }
    }
    const vider = () => {
      checkedItems.value = [];
      page.value = 1;
      selectAll.value = false;
    }
    const soumission = async () => {
      const result = await Swal.fire({
        text: `Vous êtes sur le point de valider les arrièrés de ce secteur. Continuer ?`,
        icon: "warning",
        buttonsStyling: true,
        showCancelButton: true,
        confirmButtonText: "Oui",
        cancelButtonText: `Non`,
        heightAuto: false,
        customClass: {
          confirmButton: "btn btn-danger",
        },
      });
      if (result.isConfirmed) {
        var values = {};
        values["contrats"] = checkedItems.value;
        values["secteur"] = secteur.value;
        values["etat"] = true;
        await ApiService.post("/validation", values)
          .then(({ data }) => {
            if (data.code == 201) {
              success(data.message);
              actionRecherche(page.value, limit.value);
            }
          })
          .catch(({ response }) => {
            error(response.data.message);
            vider();
          });
      }

    };

    const telecharger = async () => {
      valideEtape3.value = false;
      isLoading.value = true;
      try {
        const element = {
          motCle: motCle.value,
          secteur: secteur.value,
        };
        const response = await axios.post("/contrat/ayant/arrieres/export", element);
        const downloadUrl = await getUrlApiForFiles("Excel", response.data.data + ".xlsx");

        await downloadExcel(downloadUrl);
        openNewWindow({ reference: (response.data.data) }, "Excel");
        valideEtape3.value = true;
      } catch (err) {
        if (axios.isAxiosError(err) && err.response) {
          error(err.response.data.message || err.message);
        } else {
          if (err instanceof Error) {
            error(err.message);
          } else {
            error(String(err));
          }
        }
        valideEtape3.value = true;
      } finally {
        isLoading.value = false;
      }
    };

    const openAndPrint = (url: string) => {
      const newWindow = window.open(url, "_blank");

      if (newWindow) {
        newWindow.onload = () => {
          newWindow.print();
        };
      } else {
        console.error("Impossible d'ouvrir la fenêtre");
      }
    };

    function openNewWindow(data: any, dossier = "Excel") {
      openAndPrint(getUrlApiForFiles(dossier, data.reference + ".xlsx"));
    }


    return {
      checkedItems,
      contrats,
      checkboxes,
      suppression,
      selectedItem,
      recharger,
      show_Modal,
      page,
      secteur,
      selectAllCheckbox,
      secteursOptions,
      totalPages,
      limit,
      selectAll,
      handleSelectAll,
      formatWithThousandSeparator,
      separateur,
      totalElements,
      handlePaginate,
      searchTerm,
      motCle,
      soumission,
      handleChange,
      contratEmplacements,
      typeT,
      ajoutArr,
      telecharger,
      valideEtape3,
      isLoading,
      openNewWindow
    };
  },
});
</script>